var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-auto-refresh"},[(_vm.autoRefreshOn)?_c('span',[_vm._v("[Refresh in "+_vm._s(_vm.remainingTime)+"]")]):_c('span',[_vm._v("Auto-Refresh")]),_c('q-checkbox',{model:{value:(_vm.autoRefreshOn),callback:function ($$v) {_vm.autoRefreshOn=$$v},expression:"autoRefreshOn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }